import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';

import { EmpresaSituacaoCadastralPipe } from './pipes';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        EmpresaSituacaoCadastralPipe
    ],
    exports: [
        EmpresaSituacaoCadastralPipe
    ],
    providers: [
        EmpresaSituacaoCadastralPipe
    ]
})
export class EmpresaSituacaoCadastralModule { }
